/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/no-danger-with-children */
import Link from 'next/link'
import { Button, Col, Row } from 'react-bootstrap'
import Badge from 'react-bootstrap/Badge'
import Image from 'next/image'
import shortMonthDateBlog from 'src/@shared/functions/dateFormat'

import styles from './BlogVertical.module.scss'

export type BlogVerticalButtonProps = { label: string; link: string; variant: string; external?: boolean }

export type BlogVerticalProps = {
    imageUrl: string
    title: string
    halfTitle?: string
    subtitle: string
    datePublished?: Date
    footer?: string
    customClass?: string
    col1?: number
    col2?: number
    colLg1?: number
    colLg2?: number
    colXl1?: number
    colXl2?: number
    linkButton?: BlogVerticalButtonProps[]
}

export default function BlogVertical({
    imageUrl,
    title,
    halfTitle,
    subtitle,
    datePublished,
    footer,
    customClass,
    col1,
    col2,
    colLg1,
    colLg2,
    colXl1,
    colXl2,
    linkButton,
}: BlogVerticalProps) {
    const newLocal = subtitle ?? ''
    const componentClass = `BlogVertical ${styles.BlogVertical} ${customClass ?? ''}`

    const formattedDate = shortMonthDateBlog(datePublished ? datePublished : '')

    function BtnLink({ label, link, variant, external }: BlogVerticalButtonProps) {
        const isExternal = external ?? false
        if (isExternal) {
            return (
                <a target="_blank" href={link} rel="noopener noreferrer">
                    <Button variant={variant} className="btnBlogVertical">
                        {label}
                    </Button>
                </a>
            )
        }
        return (
            <Link href={link}>
                <Button variant={variant} className="btnBlogVertical">
                    {label}
                </Button>
            </Link>
        )
    }

    return (
        <div className={componentClass}>
            <Row>
                <Col className="featuredImage" md={col1 ? col1 : 6} lg={colLg1 ? colLg1 : 6} xl={colXl1 ? colXl1 : 6}>
                    <Image className="w-100 position-relative" src={imageUrl} alt="Casper Labs" fill />
                </Col>
                <Col
                    className="featuredContent position-relative overflow-hidden d-flex flex-column justify-content-center"
                    md={col2 ? col2 : 6}
                    lg={colLg2 ? colLg2 : 6}
                    xl={colXl2 ? colXl2 : 6}
                >
                    <p className="half-title">{halfTitle}</p>
                    <span className="h4 mb-4">{title}</span>
                    {datePublished && <p className="date">{formattedDate}</p>}
                    <div dangerouslySetInnerHTML={{ __html: newLocal }}>{}</div>
                    <div className={`d-flex btnListMobile ${styles.btnListMobile}`}>
                        {linkButton &&
                            linkButton.map((p: BlogVerticalButtonProps, index: number) => (
                                <BtnLink
                                    key={index}
                                    label={p.label}
                                    link={p.link}
                                    variant={p.variant}
                                    external={p.external}
                                />
                            ))}
                    </div>
                    {footer && <Badge bg="secondary">{footer}</Badge>}
                </Col>
            </Row>
        </div>
    )
}
